export const THROTTLE_MS = 50;
export const THROTTLE_MAP_UPDATE_MS = 10; // moving the map should be more responsive than editing feature
